import ActionTypes from "../actions/actionTypes";

const initialState = {
  callTo: null,
  callStatus: null,
  calling: false,
  text_in: "",
  text_out: "",
  text_combined: "",
  text_dtmf: "",
  text_unread: false,
  videoVisible: true,
  textVisible: true,
  soundOn: true,
  dialerVisible: false,
  selfViewVisible: true,
  showMore: false,
  videoMode: true,
  audio: true,
  video: true,
  knockknock: false,
};

const callReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CALL_ANSWER:
      state = {
        ...state,
        calling: true,
        callStatus: "INCALL",
        text_in: "",
        text_out: "",
        text_combined: "",
        text_dtmf: "",
        text_unread: false,
        videoVisible: true,
        textVisible: true,
        soundOn: true,
        dialerVisible: false,
        selfViewVisible: true,
        showMore: false,
        videoMode: true,
        knockknock: false,
      };
      break;
    case ActionTypes.CHANGE_VIEW:
      state = {
        ...state,
        view: action.view,
      };
      break;
    case ActionTypes.CALL_CALL:
      state = {
        ...state,
        calling: true,
        callStatus: "OUTGOING",
        callB: action.payload,
        callBName: null,
        knockknock: false,
      };
      break;
    case ActionTypes.HANGUP:
      state = {
        ...state,
        calling: false,
        callStatus: "HANGUPA",
      };
      break;
    case ActionTypes.CALL_DTMF:
      state = {
        ...state,
        text_dtmf: notMaskDtmf(state.text_dtmf, action.payload),
      };
      break;
    case ActionTypes.CALL_REJECT:
      state = {
        ...state,
        calling: false,
        callStatus: "REJECTEDB",
      };
      break;
    case ActionTypes.CALL_TEXT_MSG_IN:
      state = {
        ...state,
        text_in: state.text_in + action.payload,
        text_combined: state.text_combined + action.payload,
        text_unread: true,
      };
      break;
    case ActionTypes.CALL_TEXT_MSG_IN_CLEAR:
      state = {
        ...state,
        text_in: "",
      };
      break;
    case ActionTypes.CALL_TEXT_MSG_IN_DEL:
      var text = state.text_in;

      if (text.length > 0) {
        state = {
          ...state,
          text_in: text.substring(0, text.length - 1),
          text_combined: state.text_combined.substring(
            0,
            state.text_combined.length - 1
          ),
        };
      } else {
        state = {
          ...state,
        };
      }
      break;
    case ActionTypes.CALL_TEXT_MSG_OUT:
      state = {
        ...state,
        text_out: state.text_out + action.payload,
        text_combined: state.text_combined + action.payload,
      };
      break;
    case ActionTypes.CALL_TEXT_MSG_OUT_CLEAR:
      state = {
        ...state,
        text_out: "",
      };
      break;
    case ActionTypes.CALL_TEXT_MSG_OUT_DEL:
      var text2 = state.text_out;

      if (text2.length > 0) {
        state = {
          ...state,
          text_out: text2.substring(0, text2.length - 1),
          text_combined: state.text_combined.substring(
            0,
            state.text_combined.length - 1
          ),
        };
      } else {
        state = {
          ...state,
        };
      }
      break;
    case ActionTypes.SIP_INVITE_RECIEVED:
      state = {
        ...state,
        callB: action.payload.callB,
      };
      break;
    case ActionTypes.SIP_CALL_ACCEPTED_LOCAL:
      state = {
        ...state,
        audioavailable: action.payload.audio,
        textavailable: action.payload.text,
        videoavailable: action.payload.video,
        text_in: "",
        text_out: "",
        text_combined: "",
        text_dtmf: "",
        text_unread: false,
        videoVisible: action.payload.video,
        textVisible: action.payload.text,
        soundOn: true,
        dialerVisible: false,
        selfViewVisible: action.payload.video,
        showMore: false,
        videoMode: true,
        audio: true,
        video: true,
        knockknock: false,
      };
      break;
    case ActionTypes.SIP_CALLING:
      state = {
        ...initialState,
        audioavailable: action.payload.audio,
        textavailable: action.payload.text,
        videoavailable: action.payload.video,
        callB: action.payload.callB,
        callBName: action.payload.callBName,
      };
      if (action.payload.video === true) state.videoVisible = true;
      if (action.payload.text === true) {
        state.textVisible =
          typeof action.payload.options.textVisible === "undefined"
            ? true
            : action.payload.options.textVisible;
      }
      break;
    case ActionTypes.CALL_MUTE_AUDIO:
      state = {
        ...state,
        audio: !state.audio,
      };
      break;
    case ActionTypes.CALL_MUTE_REMOTE_AUDIO:
      state = {
        ...state,
        soundOn: !state.soundOn,
      };
      break;
    case ActionTypes.CALL_MUTE_VIDEO:
      state = {
        ...state,
        video: !state.video,
      };
      break;
    case ActionTypes.CALL_HIDE_VIDEO:
      state = {
        ...state,
        videoVisible: !state.videoVisible,
      };
      break;
    case ActionTypes.CALL_HIDE_TEXT:
      state = {
        ...state,
        textVisible: !state.textVisible,
      };
      break;
    case ActionTypes.CALL_HIDE_DIALER:
      state = {
        ...state,
        dialerVisible: !state.dialerVisible,
      };
      break;
    case ActionTypes.CALL_HIDE_SELFVIEW:
      state = {
        ...state,
        selfViewVisible: !state.selfViewVisible,
      };
      break;
    case ActionTypes.CALL_SHOW_MORE:
      state = {
        ...state,
        showMore: !state.showMore,
      };
      break;
    case ActionTypes.CALL_TOGGLE_VIDEO_MODE:
      state = {
        ...state,
        videoMode: !state.videoMode,
        text_unread: false,
      };
      break;
    case ActionTypes.CALL_KNOCK_KNOCK:
      state = {
        ...state,
        knockknock: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
};

// eslint-disable-next-line
function maskDtmf(current, dtmf) {
  var ret = "";
  for (var i = 0; i < 15 && i < current.length; i++) {
    ret = ret + "*";
  }
  ret = ret + dtmf;
  return ret;
}

// eslint-disable-next-line
function notMaskDtmf(current, dtmf) {
  console.log("Current", current);
  console.log("DTMF", dtmf);
  return current + dtmf;
}

export default callReducer;






// WEBPACK FOOTER //
// ./src/reducers/callReducer.js